import * as React from 'react'
import { useTranslation } from 'react-i18next'

import chartColors from 'assets/styles/scss/shared/_chart-colors.module.scss'
import styles from 'components/Shared/Charts/ChartTooltip/ChartTooltip.module.scss'

type CustomTooltip = {
  title: string
  dotColor: string[]
  content: { [key: string]: string }
  xAxisLabel?: string
  shouldTranslate?: boolean
}

export const ChartTooltip = ({
  title,
  dotColor,
  content,
  xAxisLabel,
  shouldTranslate = false,
}: CustomTooltip) => {
  const { t } = useTranslation()

  return (
    <div className={styles.tooltipBody}>
      <div className={styles.tooltipTitle}>{title}</div>
      {xAxisLabel && (
        <div className={styles.tooltipSubTitle} data-testid="tooltip-subtitle">
          {xAxisLabel}
        </div>
      )}

      {Object.keys(content).map((key, index) => (
        <div className={styles.flexContainer} key={key}>
          <div
            style={{
              backgroundColor: dotColor[index],
            }}
            className={styles.legendDot}
          />
          <div
            style={{
              color: chartColors.black,
            }}
            className={styles.tooltipContent}
          >
            {shouldTranslate ? t(`charts.${key}`) : key}: {content[key]}
          </div>
        </div>
      ))}
    </div>
  )
}
